import axios from 'axios';

class AxiosAPI {
  constructor() {
    // `${process.env.LUMINARY_API_HOST}`
    this.base_url = '';
  }

  setDefaultHeader(name, value) {
    axios.defaults.headers.common[name] = value;
  }

  getList(endpoint, params) {
    const url = `${this.base_url}/${endpoint}`;
    const config = {};
    config.params = params;
    return axios.get(url, config).then(resp => resp.data);
  }

  get(endpoint, params, isFullURL = false) {
    let url = `${this.base_url}/${endpoint}`;
    if (isFullURL) {
      url = endpoint;
    }
    const config = {};
    config.params = params;

    return axios.get(url, config).then(resp => resp.data);
  }

  post(endpoint, data, queryParams) {
    const url = `${this.base_url}/${endpoint}`;
    const config = {};
    if (queryParams) {
      config.params = queryParams;
    }
    return axios.post(url, data, config).then(resp => resp.data);
  }

  put(endpoint, data) {
    const url = `${this.base_url}/${endpoint}`;
    const config = {};
    return axios.put(url, data, config).then(resp => resp.data);
  }

  delete(endpoint, params) {
    const url = `${this.base_url}/${endpoint}`;
    const config = {};
    config.params = params;
    return axios.delete(url, config).then(resp => resp.data);
  }
}

export default AxiosAPI;



// WEBPACK FOOTER //
// ./app/src/services/AxiosAPI.js